import { render, staticRenderFns } from "./OfficeInvoice.vue?vue&type=template&id=77a135ea&scoped=true&"
import script from "./OfficeInvoice.vue?vue&type=script&lang=ts&"
export * from "./OfficeInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeInvoice.vue?vue&type=style&index=0&id=77a135ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a135ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow,VSpacer})
